import React, { useEffect, useState } from "react";

import { Button, Row } from "antd";

import moment from "moment/moment";

import LineChartGraph from "./LineChartGraph";

const summarySalesData = [
  { label: "총 매출금액", color: "#117ffa", unit: "원" },
  { label: "총 판매건수", color: "#1ca717", unit: "건" },
  { label: "평균 객단가", color: "#bbc71d", unit: "원" },
];
const summarySalesCategory = [
  { label: "매출금액", value: "sales", unit: "원" },
  { label: "판매건수", value: "count", unit: "건" },
  { label: "객단가", value: "average", unit: "원" },
];
const summaryInflowData = [
  { label: "총 방문자수", color: "#117ffa", unit: "명" },
  { label: "방문자 중 신규회원", color: "#1ca717", unit: "명" },
  { label: "방문자 중 기존회원", color: "#bbc71d", unit: "명" },
  { label: "누적회원수", color: "#212529", unit: "명" },
];
const summaryInflowCategory = [
  { label: "방문자수", value: "total_visitor", unit: "명" },
  { label: "신규회원", value: "new_user", unit: "명" },
  { label: "기존회원", value: "old_user", unit: "명" },
];

const StatisticsGraph = ({
  title = "판매분석",
  searchOptions,
  summary,
  graphData,
}) => {
  const [data, setData] = useState([]);
  const [selectOption, setSelectOption] = useState({
    category: "",
    category_name: "",
    unit: "",
  });

  useEffect(() => {
    if (title === "판매분석") {
      // 총 매출금액, 총 판매건수, 평균 객단가
      setData([
        summary?.total_sales_amount ?? 0,
        summary?.total_purchases_num ?? 0,
        summary?.unit_price_avg ?? 0,
      ]);
    } else {
      // 총 방문자수, 방문자 중 신규회원, 방문자 중 기존회원, 누적회원수
      setData([
        summary?.total_visitor_num ?? 0,
        summary?.new_user_num ?? 0,
        summary?.old_user_num ?? 0,
        summary?.totalCnt ?? 0,
      ]);
    }
  }, [summary]);

  useEffect(() => {
    if (title === "판매분석") {
      setSelectOption({
        ...searchOptions,
        category: summarySalesCategory[0].value,
        category_name: summarySalesCategory[0].label,
        unit: summarySalesCategory[0].unit,
      });
    } else {
      setSelectOption({
        ...searchOptions,
        category: summaryInflowCategory[0].value,
        category_name: summaryInflowCategory[0].label,
        unit: summaryInflowCategory[0].unit,
      });
    }
  }, [title]);

  return (
    <>
      <Row
        className="product-register-border-box"
        justify={"space-between"}
        wrap={false}
        style={{ marginTop: 20, borderBottom: 0 }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <span className="product-register-box-title">{title}</span>
        </div>
      </Row>
      <div
        className="product-register-border-box statistic-graph"
        style={{ padding: "20px 25px 40px", height: "fit-content" }}
      >
        <div className={`graph-summary-div`}>
          <div className={`graph-summary-date`}>
            <h3>{moment(searchOptions.startDate).format("YYYY.MM.DD")}</h3>
            <h3>~</h3>
            <h3>{moment(searchOptions.endDate).format("YYYY.MM.DD")}</h3>
          </div>
          <div className={`graph-summary-data-list`}>
            {(title === "판매분석" ? summarySalesData : summaryInflowData).map(
              (item, idx) => (
                <div
                  className={`graph-summary-data-each`}
                  key={`graph-summary-data-each-${item.label}`}
                >
                  <div className={`graph-summary-data-label`}>
                    <div
                      className={`graph-summary-data-label-color`}
                      style={{ backgroundColor: item.color }}
                    />
                    <p>{item.label}</p>
                  </div>
                  <p
                    className={`graph-summary-data`}
                    style={{ color: item.color }}
                  >
                    {data[idx]?.toLocaleString()}
                    {item.unit}
                  </p>
                </div>
              ),
            )}
          </div>
        </div>
        <div className={`graph-summary-category-div`}>
          {(title === "판매분석"
            ? summarySalesCategory
            : summaryInflowCategory
          ).map((item, idx) => (
            <Button
              className={`graph-summary-category-button ${
                item.value === selectOption.category ? "active" : ""
              }`}
              onClick={() => {
                setSelectOption({
                  ...searchOptions,
                  category: item.value,
                  category_name: item.label,
                  unit: item.unit,
                });
              }}
            >
              {item.label}
            </Button>
          ))}
        </div>
        {/* 차트 표기하기 */}
        <LineChartGraph selectOption={selectOption} graphData={graphData} />
      </div>
    </>
  );
};

export default StatisticsGraph;
